import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class OriginThemeService {
  origines = [
    'afisante_affiliation',
    'mutuelleonline_affiliation',
    'labonnemutuelle_affiliation',
    'assuranceetmutuelle_affiliation',
  ];

  c_afi_aff: string = '#14A0D7';
  c_mut_aff: string = '#D44B55';
  c_lab_aff: string = '#84C13D';
  c_ass_aff: string = '#6F9A43';

  theme_afisante_affiliation = [
    {
      btn_bg: 'linear-gradient(231.74deg, #14A0D7 -26.89%, #5EBEE3 64.63%)',
      choixRadio_theme: 'th_afisante_affiliation',
      avatar: 'souscription/avatar_afisante_affiliation.svg',
      location: 'souscription/location_afisante_affiliation.svg',
      social: 'souscription/Social_afisante_affiliation.svg',
      beneficiaire: 'souscription/beneficiaire_afisante_affiliation.svg',
    },
    {
      btn_bg: 'linear-gradient(231.74deg, #14A0D7 -26.89%, #5EBEE3 64.63%)',
      btn_bg_simple: this.c_afi_aff,
      btn_border_simple: '2px solid #14A0D7',
      bg_justification: '#14a0d73d',
      c_ratio_theme: this.c_afi_aff,
      donate_theme: 'th_afisante_affiliation',
    },
    {
      c_base: this.c_afi_aff,
      btn_bg: 'linear-gradient(231.74deg, #14A0D7 -26.89%, #5EBEE3 64.63%)',
      avatar: 'souscription/avatar_afisante_affiliation.svg',
      location: 'souscription/location_afisante_affiliation.svg',
      pousette: 'souscription/pousette_afisante_affiliation.svg',
      mail_small: 'souscription/mail_small_afisante_affiliation.svg',
      phone: 'souscription/phone_afisante_affiliation.svg',
      parapluie: 'souscription/parapluie_afisante_affiliation.svg',
    },
    {
      c_theme: 'th_afisante_affiliation',
      bravo: 'souscription/bravo_afisante_affiliation.svg',
      dowload: 'souscription/dowload_afisante_affiliation.svg',
    },
  ];

  theme_mutuelleonline_affiliation = [
    {
      btn_bg: 'linear-gradient(231.74deg, #93A4A3 -26.89%, #D44B55 64.63%)',
      choixRadio_theme: 'th_mutuelleonline_affiliation',
      avatar: 'souscription/avatar_mutuelleonline_affiliation.svg',
      location: 'souscription/location_mutuelleonline_affiliation.svg',
      social: 'souscription/Social_mutuelleonline_affiliation.svg',
      beneficiaire: 'souscription/beneficiaire_mutuelleonline_affiliation.svg',
    },
    {
      btn_bg: 'linear-gradient(231.74deg, #93A4A3 -26.89%, #D44B55 64.63%)',
      btn_bg_simple: this.c_mut_aff,
      btn_border_simple: '2px solid #D44B55',
      bg_justification: '#d44b5545',
      c_ratio_theme: this.c_mut_aff,
      donate_theme: 'th_mutuelleonline_affiliation',
    },
    {
      c_base: this.c_mut_aff,
      btn_bg: 'linear-gradient(231.74deg, #93A4A3 -26.89%, #D44B55 64.63%)',
      avatar: 'souscription/avatar_mutuelleonline_affiliation.svg',
      location: 'souscription/location_mutuelleonline_affiliation.svg',
      pousette: 'souscription/pousette_mutuelleonline_affiliation.svg',
      mail_small: 'souscription/mail_small_mutuelleonline_affiliation.svg',
      phone: 'souscription/phone_mutuelleonline_affiliation.svg',
      parapluie: 'souscription/parapluie_mutuelleonline_affiliation.svg',
    },
    {
      c_theme: 'th_mutuelleonline_affiliation',
      bravo: 'souscription/bravo_mutuelleonline_affiliation.svg',
      dowload: 'souscription/dowload_mutuelleonline_affiliation.svg',
    },
  ];

  theme_labonnemutuelle_affiliation = [
    {
      btn_bg: 'linear-gradient(231.74deg, #69A8FE -26.89%, #84C13D 64.63%)',
      choixRadio_theme: 'th_labonnemutuelle_affiliation',
      avatar: 'souscription/avatar_labonnemutuelle_affiliation.svg',
      location: 'souscription/location_labonnemutuelle_affiliation.svg',
      social: 'souscription/Social_labonnemutuelle_affiliation.svg',
      beneficiaire: 'souscription/beneficiaire_labonnemutuelle_affiliation.svg',
    },
    {
      btn_bg: 'linear-gradient(231.74deg, #69A8FE -26.89%, #84C13D 64.63%)',
      btn_bg_simple: this.c_lab_aff,
      btn_border_simple: '2px solid #84C13D',
      bg_justification: '#84c13d61',
      c_ratio_theme: this.c_lab_aff,
      donate_theme: 'th_labonnemutuelle_affiliation',
    },
    {
      c_base: this.c_lab_aff,
      btn_bg: 'linear-gradient(231.74deg, #69A8FE -26.89%, #84C13D 64.63%)',
      avatar: 'souscription/avatar_labonnemutuelle_affiliation.svg',
      location: 'souscription/location_labonnemutuelle_affiliation.svg',
      pousette: 'souscription/pousette_labonnemutuelle_affiliation.svg',
      mail_small: 'souscription/mail_small_labonnemutuelle_affiliation.svg',
      phone: 'souscription/phone_labonnemutuelle_affiliation.svg',
      parapluie: 'souscription/parapluie_labonnemutuelle_affiliation.svg',
    },
    {
      c_theme: 'th_labonnemutuelle_affiliation',
      bravo: 'souscription/bravo_labonnemutuelle_affiliation.svg',
      dowload: 'souscription/dowload_labonnemutuelle_affiliation.svg',
    },
  ];

  theme_assuranceetmutuelle_affiliation = [
    {
      btn_bg: 'linear-gradient(231.74deg, #B6BBB1 -26.89%, #6F9A43 64.63%)',
      choixRadio_theme: 'th_assuranceetmutuelle_affiliation',
      avatar: 'souscription/avatar_assuranceetmutuelle_affiliation.svg',
      location: 'souscription/location_assuranceetmutuelle_affiliation.svg',
      social: 'souscription/Social_assuranceetmutuelle_affiliation.svg',
      beneficiaire:
        'souscription/beneficiaire_assuranceetmutuelle_affiliation.svg',
    },
    {
      btn_bg: 'linear-gradient(231.74deg, #B6BBB1 -26.89%, #6F9A43 64.63%)',
      btn_bg_simple: this.c_ass_aff,
      btn_border_simple: '2px solid #6F9A43',
      bg_justification: '#84c13d61',
      c_ratio_theme: this.c_ass_aff,
      donate_theme: 'th_assuranceetmutuelle_affiliation',
    },
    {
      c_base: this.c_ass_aff,
      btn_bg: 'linear-gradient(231.74deg, #B6BBB1 -26.89%, #6F9A43 64.63%)',
      avatar: 'souscription/avatar_assuranceetmutuelle_affiliation.svg',
      location: 'souscription/location_assuranceetmutuelle_affiliation.svg',
      pousette: 'souscription/pousette_assuranceetmutuelle_affiliation.svg',
      mail_small: 'souscription/mail_small_assuranceetmutuelle_affiliation.svg',
      phone: 'souscription/phone_assuranceetmutuelle_affiliation.svg',
      parapluie: 'souscription/parapluie_assuranceetmutuelle_affiliation.svg',
    },
    {
      c_theme: 'th_assuranceetmutuelle_affiliation',
      bravo: 'souscription/bravo_assuranceetmutuelle_affiliation.svg',
      dowload: 'souscription/dowload_assuranceetmutuelle_affiliation.svg',
    },
  ];

  GetBaseColor(origin: string) {
    const colorMap: any = {
      afisante_affiliation: this.c_afi_aff,
      mutuelleonline_affiliation: this.c_mut_aff,
      labonnemutuelle_affiliation: this.c_lab_aff,
      assuranceetmutuelle_affiliation: this.c_ass_aff,
    };
    return colorMap[origin] || null;
  }

  GetTheme(origin: any, etape: number) {
    const themeMap: any = {
      afisante_affiliation: this.theme_afisante_affiliation,
      mutuelleonline_affiliation: this.theme_mutuelleonline_affiliation,
      labonnemutuelle_affiliation: this.theme_labonnemutuelle_affiliation,
      assuranceetmutuelle_affiliation:
        this.theme_assuranceetmutuelle_affiliation,
    };
    return themeMap[origin] ? themeMap[origin][etape - 1] : null;
  }

  IsTrueOrigine(origin: string) {
    return this.origines.includes(origin);
  }

  GetClassTheme(origin: any) {
    const themeMap: any = {
      afisante_affiliation: 'th_afisante_affiliation',
      mutuelleonline_affiliation: 'th_mutuelleonline_affiliation',
      labonnemutuelle_affiliation: 'th_labonnemutuelle_affiliation',
      assuranceetmutuelle_affiliation: 'th_assuranceetmutuelle_affiliation',
    };
    return themeMap[origin] || null;
  }
}
